/**
 * ตารางเวรทีม (พนักงานทุกคนดูได้) — อ่านอย่างเดียว.
 *
 * เดิมพนักงานเห็นได้แค่กะของตัวเอง (/my-schedule) เลยไม่รู้ว่าวันนั้นใครเข้าเวร
 * ด้วย ต้องไปถามหัวหน้าทุกที. หน้านี้ใช้ตารางตัวเดียวกับฝั่ง HR แต่ backend
 * (/shift/roster-view) จำกัดให้เห็นเฉพาะคนในแผนกตัวเอง และไม่บอกประเภทวันลา
 * ของเพื่อนร่วมงาน.
 */
import { PageLayout } from '../components/layout/PageLayout';
import { HRRosterCalendarContent } from './hr/RosterCalendar';

export function TeamRoster() {
  return (
    <PageLayout title="ตารางเวรทีม">
      <p className="text-xs text-warm-gray mb-3">
        ตารางเวรของทีมคุณ — เลือกช่วงวันที่ที่อยากดูได้ แก้ไขไม่ได้ (ถ้าต้องแก้เวร ให้แจ้งหัวหน้า)
      </p>
      <HRRosterCalendarContent />
    </PageLayout>
  );
}
